import React from "react";
import "./MobileBottomAppBar.css";
import { Box } from "@mui/material";

interface MobileBottomAppBarProps {
    button: JSX.Element;
}

const MobileBottomAppBar = (props: MobileBottomAppBarProps) => {
    return <Box className="bottom-nav-bar-container">{props.button}</Box>;
};

export default MobileBottomAppBar;
